import { Context } from '../context';
import { makeAddItems } from './add-items';
import { makeChangeQuantity } from './change-quantity';
import { makeInit } from './init';
import { makeRemoveItems } from './remove-items';
import { makeUpdateNote } from './update-note';
import { makeRefresh } from './refresh';
import { reload } from './reload';
const { addItemsToCart , changeItemQuantity , fetchCartContents , updateCartNote  } = Context;
const updateNosto = ()=>{
    if (typeof window !== 'undefined' && window.Nosto) {
        window.Nosto.reloadCart();
    }
};
export const ActionHandler = {
    reload,
    refresh: makeRefresh({
        fetchCartContents
    }),
    addItems: makeAddItems({
        addItemsToCart,
        fetchCartContents,
        afterUpdate: updateNosto
    }),
    changeQuantity: makeChangeQuantity({
        changeItemQuantity,
        afterUpdate: updateNosto
    }),
    init: makeInit({
        fetchCartContents
    }),
    removeItems: makeRemoveItems({
        changeItemQuantity
    }),
    updateNote: makeUpdateNote({
        updateCartNote
    })
};
